// Library Utilities
import React from "react";
import { useIdleTimer } from "react-idle-timer";
// Hooks
import { logout } from "../../utils/logout";

export default function IdleTimerContainer(props: any) {
  const handleOnIdle = async () => {
    await logout({ redirectToLogin: true });
    localStorage.removeItem("organisation_id");
  };

  useIdleTimer({
    // change the timeout its configurable
    timeout: 1000 * 60 * 30,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return <div className="mb-5">{props.children}</div>;
}
